import React, { useEffect, useState } from 'react'
import Image from '../../../components/common/Image'
import Fee from '../../../components/service/fee'
import IdentityInfo from '../../../components/service/identityInfo'
import { TakePreBill, AddNewOrder } from '../../../api/order'
import { addOrderSuccess } from '../../../store/userSlice'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { GetInfoByAddressOrXY, GetPlanRoute,GetPlaceAutocomplete ,GetPlaceDetails} from '../../../api/map8'
import Notification from '../../../components/common/Error/Notification'
const Confirm = ({ service, parameters, data, userInfo, onBack, storeUser }) => {
    const [modal, setModal] = useState(null)
    // const [estimated, setEstimated] = useState(null)
    const [preBill, setPreBill] = useState(null)
    const [btnDisabled, setBtnDisabled] = useState(false)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const submit = async (type) => {
        // !type 新增訂單
        if (!type) setBtnDisabled(true)

        let originPostCode = await GetInfoByAddressOrXY({ address: data.address })
        let postcode = {
            origin: "",
            destination: "",
            coordinate: {
                lat_s: data.position.lat,
                lng_s: data.position.lng,

            }
        }
        if (originPostCode?.statusCode === 200) {
            postcode.origin = originPostCode.result[0]["postcode"]
        }

        let destination = data.destination
        if (destination) {
            let destination_add = destination.vmp_id ?
                destination.vmp_id.vmpAddress : destination.destination_address
            let destinationPostCode = await GetInfoByAddressOrXY({ address: destination_add })
            if (destinationPostCode?.statusCode === 200) {
                postcode.destination = destinationPostCode.result[0]["postcode"]
                postcode.coordinate = {
                    ...postcode.coordinate,
                    lng_e: destinationPostCode.result[0].geometry.location.lng,
                    lat_e: destinationPostCode.result[0].geometry.location.lat,

                }
            }
        }
        let obj = {
            user_info: {
                name: userInfo.name,
                phone: userInfo.phone01
            },
            user_car: {
                brand_id: userInfo.brand?.brandId,
                model_id: userInfo.model?.modelId,
                wheel_drive: userInfo.model?.wheelDrive,
                plate_num: userInfo.plate_num,
                type: userInfo.type?.value,
                color: userInfo?.color || ""
            },
            service_record: {
                service_name: service.name
            },
            service_location: {
                location_type: data.position.name,
                origin_lat: data.position.lat,
                origin_lon: data.position.lng,
                origin_address: `${data.position.id<2?postcode.origin:''}${data.address}`
            }
        }
        if (userInfo.ins_info) {
            obj["ins_info"] = userInfo.ins_info
        }

        if (storeUser.info) {
            const { info } = storeUser
            obj.tms_offer_cust = info.option?.id
            obj.tms_offer_pno = info.offer_pno
            obj.offer_pnoname = info.offer_pnoname
            obj.crm_0800 = info.crm_0800
        }

        //停車場類型
        if (data.type) {
            obj.service_location.park_type = data.type.name
            // 停車場類型：地下室/立體
            if (data.type.id === 1) {
                //需帶入字串
                obj.service_location.park_floor = data.floor > 0 ?
                    data.floor.toString() : `B${(data.floor - 1) * -1}`
                //若停車場有限制高度
                if (data.isLimitHeight) {
                    obj.service_location.park_max_clearance = data.limitHeight * 1
                }
            }
        }


        //國道高速 、快速道路、休息站
        let reform_origin = {}
        let GetPlaceAutocomplete_keyword= ''
        //國道高速
        if (data.freeway?.freewayListID) {
            let freeway = data.freeway
            obj.service_location.freeway_region_id = 
            data.freewayRegionId || data.freeway_sub?.directionInfos[0]['freewayRegionId']
       
            if(data.mileage){
obj.service_location.mileage_signs_direction =
                `${data.mileage}/${data.direction?.value?.replace("下", "")}`
            }
            //id ===1 國道分隊;  id ===2 休息站
            if(data.freeway_type.id < 3){
                GetPlaceAutocomplete_keyword =`${data.freeway_type.id===1?data.freeway_sub.typeName:''}${data.freeway_sub.name}${data.direction?.name}` 

            }else{
                GetPlaceAutocomplete_keyword =`${freeway.nickName}-${data.mileage}K`  
            }
            
        }
       
        //快速道路
        if (data.expressway_id?.expressway_id) {
            obj.service_location.expressway_id = data.expressway_id.expressway_id
            if (data.mileage) {
                obj.service_location.mileage_signs_direction =
                    `${data.mileage}/${data.direction.name}`
            }
            GetPlaceAutocomplete_keyword =`${data.expressway_id
.name.replace("線","")}-${data.mileage}K`
        }
        // console.log(data)
        // console.log(obj)
        // console.log(GetPlaceAutocomplete_keyword)
        // 高速公路 OR 快速道路所在位置(車道中、路肩、國道分隊、休息站)

        if(data.position.id ===2 || data.position.id ===3){
            obj.service_location.freeway_location = data.express_location?.name || data.freeway_type?.name
        }
       

        if(GetPlaceAutocomplete_keyword){
            //取得國道高速/快速道路的座標
            let place = await GetPlaceAutocomplete({ keyword: GetPlaceAutocomplete_keyword })
            if(place?.statusCode === 200){
                let place_id = place.result[0].place_id
                let GetPlaceDetails_res = await GetPlaceDetails({place_id:place_id})
                if(GetPlaceDetails_res?.statusCode === 200){   
                    const {location} = GetPlaceDetails_res.result.geometry  
                    const {postcode,city,town} = GetPlaceDetails_res.result
                    reform_origin.origin_lat = location.lat
                    reform_origin.origin_lon = location.lng   
                    reform_origin.origin_address = `${postcode}${city}${town}${obj.service_location.origin_address}`
                  
                }
            }
        }
        obj.service_location={
            ...obj.service_location,
            ...reform_origin
        }
        if (destination) {
            // destination_lat,destination_lon
            if (destination.vmp_id) {
                obj.service_location.vmp_id = destination.vmp_id.vmpID
                obj.service_location.destination_address =
                    `${postcode.destination}${destination.vmp_id.vmpAddress}`
            } else {
                obj.service_location.destination_address =
                    `${postcode.destination}${destination.destination_address}`
            }
            obj.service_location.destination_lat = postcode.coordinate.lat_e
            obj.service_location.destination_lon = postcode.coordinate.lng_e
            let route = await GetPlanRoute(postcode.coordinate)
            if (route?.statusCode === 200) {
                //路徑規劃 （取得起訖距離和花費時間）
                obj.service_location = {
                    ...obj.service_location,
                    distance: route.result.distance,
                    // compute_time:route.result.duration,
                }
            }
        }
        if (preBill) {
            obj.tms_return_id = preBill.tms_return_id
            obj.preBillAmount = preBill.amount.toString()
            if (!type) {
                obj.prebill_item = JSON.stringify(preBill)
            }
        }
        //送水、送電無服務問題
        if (data.service) {
            Object.keys(data.service).forEach(key => {
                let value =
                    data.service[key].hasOwnProperty('text') ? data.service[key]['text'] :
                        data.service[key].hasOwnProperty('value') ? data.service[key]['value'] :
                            data.service[key]
                obj["service_record"][key] = value
                // 參數車上是否有貨物 Boolean 改成字串 ("Y"、"N") 
                if (key === 'is_cargo') obj["service_record"][key] = value ? "Y" : "N"
            })
        }

        // if(!type)return false
        // 取得試算金額 or 新增訂單
        let res = type ? await TakePreBill(obj) : await AddNewOrder(obj)
        if (res?.statusCode === 200) {
            if (type) {
                setPreBill(res.result)
            } else {
                setBtnDisabled(false)
                dispatch(addOrderSuccess(true))
                setTimeout(() => {
                    navigate("/services")
                }, 500)
            }
        } else {
            if (!type) {
                setBtnDisabled(false)
                setModal({ type: 'error', ...res })
            }
        }
    }


    useEffect(() => {
        data && submit("bill")
    }, [data])

    return (
        <>
            <div className='container'>
                <div className="page-header">
                    <button className='btn-circle' onClick={onBack}>
                        <Image src='/images/icons/arrow_left.svg' />
                    </button>
                    <div className="page_header__title">
                        <h1 className="font-heading">{service?.name || ""}資訊</h1>
                        {/* <p className="text-secondary text-scale-02">
                這將使我們派出最適合的支援
            </p> */}
                    </div>
                </div>
                <div className='confirm-block'>
                    <div className='block'>
                        <div className='d-flex info_block'>
                            <Image src={`/images/icons/${data.destination ? 'destination' : 'origin'}.svg`} />
                            <div className='desc_block'>
                                <div className='desc'>
                                    <p className='title'>{data.address}</p>
                                    <p className='text'>{data.type?.name}{data.position.name}</p>
                                </div>
                                {
                                    data.destination && (
                                        <div className='desc'>
                                            {
                                                data.destination.vmp_id ? (<>
                                                    <p className='title'>
                                                        {data.destination.vmp_id.vmpName}
                                                    </p>
                                                    <p className='text'>
                                                        {data.destination.vmp_id.vmpAddress}
                                                    </p>
                                                </>) : (<p className='title'>{data.destination.destination_name || data.destination.destination_address}</p>)
                                            }

                                        </div>
                                    )
                                }

                            </div>
                        </div>
                        <div className='list_block'>
                            <div className='desc_flex'>
                                <Image src="/images/icons/car.svg" />
                                <div className='title_block'>
                                    <p className='title'>{userInfo.plate_num}</p>
                                    <p className='text'>
                                        {userInfo.brand.cnName} {userInfo.model.modelName}
                                    </p>
                                </div>
                            </div>
                        </div>
                        {
                            storeUser.info &&
                            <div className='list_block'>
                                <div className='desc_flex'>
                                    <Image src="/images/icons/tag.svg" />
                                    <div className='title_block'>
                                        <p className='title'>{storeUser.info.offer_pnoname}</p>
                                        {/* <p className='text'>{storeUser.info.offerSubtypeName}</p> */}
                                    </div>
                                </div>
                                <div
                                    onClick={() => {
                                        setModal({ type: 'info' })
                                    }}
                                >
                                    <Image src="/images/icons/chevron_right.svg" svg />
                                </div>
                            </div>
                        }

                        {
                            preBill && (
                                <div className='list_block'>
                                    <div className='desc_flex'>
                                        <Image src="/images/icons/dollar.svg" />
                                        <div className='title_block'>
                                        {
                                            ( preBill.amount === 0) ? <p className='title'>預估服務費用</p> :
                                            (
                                            <>
                                            <p className='title'>{preBill.amount}</p>
                                            <p className='text'>試算金額僅供參考，實際服務項目及收費金額仍以客服人員確認及現場作業狀況為準。</p>
                                            </>
                                            )
                                        }
                                            
                                        </div>
                                    </div>
                                    <div
                                        onClick={() => {
                                            setModal({ type: 'fee' })
                                        }}
                                    >
                                        <Image src="/images/icons/chevron_right.svg" svg />
                                    </div>
                                </div>
                            )
                        }

                    </div>
                    <button
                        style={{ marginTop: 24 }}
                        className="btn btn-primary"
                        disabled={btnDisabled}
                        onClick={() => submit()}
                    >確定，呼叫救援</button>
                </div>

                {/* {
        modal && (
            <Notification
                {...modal}
                onConfirm={() => onAction(true)}
                onBnt02={() => onAction(false)}
            // title='要離開了嗎？' 
            // description='案件尚未成立，剛剛填入的資料將不會保存' 
            // btn02Text='確定離開'
            // okText='繼續填寫'
            // onConfirm={()=> setModal(false)}
            // onBnt02={()=>navigate(-1)}
            />
        )
    } */}
            </div>
            {modal?.type === 'info' && <IdentityInfo setModal={setModal} data={storeUser.info} />}
            {modal?.type === 'fee' && <Fee setModal={setModal} data={preBill} />}
            {
                modal?.type === 'error' && <Notification
                    title={modal.message}
                    // description='案件尚未成立，剛剛填入的資料將不會保存'
                    // btn02Text='確定離開'
                    okText='確定'
                    onConfirm={() => setModal(false)}
                />
            }

        </>
    )
}

export default Confirm